module.exports = __webpack_public_path__ + "img/GAME_BADUK.7bedc11f.png";